import { NetPriceSourceEnum } from '@/libs/enums';
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useTradeAgreementContext } from 'views/web/product/context';

const NetPriceTypeContext = createContext(null);

const NetPriceTypeContextProvider = ({ children, skuDetail }) => {
  const { selectTradeAgreement } = useTradeAgreementContext();

  const [selectNetPriceType, setSelectNetPriceType] = useState(undefined);

  const active = useMemo(() => {
    let activeType = null;
    if (selectTradeAgreement?.netPriceTypeList?.length > 1) {
      activeType = skuDetail.netPriceType || NetPriceSourceEnum.LANGE;
    }
    return activeType;
  }, [skuDetail, selectTradeAgreement]);

  useEffect(() => {
    setSelectNetPriceType(active);
  }, [active, setSelectNetPriceType]);

  const netPriceTypeData = useMemo(
    () => ({ selectNetPriceType, setSelectNetPriceType }),
    [selectNetPriceType, setSelectNetPriceType],
  );
  return (
    <NetPriceTypeContext.Provider value={netPriceTypeData}>{children}</NetPriceTypeContext.Provider>
  );
};

const useNetPriceTypeContext = () => {
  const context = useContext(NetPriceTypeContext);
  if (context === undefined) {
    throw new Error('useNetPriceTypeContext must be used within a NetPriceTypeContextProvider');
  }
  return context;
};

export { NetPriceTypeContextProvider, useNetPriceTypeContext };
